var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8651 8.83547H11.2354V1.17477C11.2284 0.869439 11.1039 0.578552 10.8877 0.362594C10.7768 0.245208 10.6424 0.152324 10.4933 0.0899177C10.3443 0.0275112 10.1838 -0.00303691 10.0222 0.00023805C9.7106 0.00315337 9.41254 0.127849 9.19184 0.347617C8.97115 0.567385 8.84538 0.864749 8.84147 1.17602V8.82797H1.18927C0.876938 8.83031 0.577864 8.95438 0.355761 9.17376C0.133658 9.39315 0.00608254 9.69049 0.000211921 10.0025C-0.0056587 10.3144 0.11064 10.6164 0.324332 10.8439C0.538025 11.0715 0.832219 11.2067 1.14424 11.2208H8.84147V18.879C8.85995 19.1834 8.99438 19.4691 9.21716 19.6776C9.43993 19.8861 9.73415 20.0014 10.0394 20C10.3447 19.9985 10.6378 19.8804 10.8586 19.6699C11.0794 19.4593 11.2111 19.1723 11.2267 18.8677V11.2283H18.8776C19.183 11.2092 19.4695 11.0741 19.6782 10.8506C19.8869 10.6271 20.0021 10.3323 20 10.0267C19.9979 9.72105 19.8787 9.42782 19.667 9.20721C19.4552 8.9866 19.167 8.85537 18.8614 8.84047",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.e7fab7a3e10d2fd1c05d895cab58836e.svg";
export { ForwardRef as ReactComponent };